import { render, staticRenderFns } from "./ConsumptionDataExchangeKugu.vue?vue&type=template&id=741eba4e&lang=pug&"
import script from "./ConsumptionDataExchangeKugu.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeKugu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports